export default __webpack_public_path__ + "static/160-min-min-fe03b6148dbc542285937f36bb8aaa67.jpg";